import { Navigate, useLocation } from "react-router-dom";
import AnimatedPage from "@/components/AnimatedPage";
import { useAuth } from "@/lib/AuthContext";
import LandingHeader from "@/components/landing/LandingHeader";
import HeroSection from "@/components/landing/HeroSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import PricingSection from "@/components/landing/PricingSection";
import LandingFooter from "@/components/landing/LandingFooter";
import { Helmet } from "react-helmet-async";
import { useEffect } from "react";

const Index = () => {
  const { user } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Check if we need to scroll to pricing section
    if (location.hash === '#pricing') {
      setTimeout(() => {
        document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location.hash]);

  // If user is logged in and there's no hash in the URL, redirect to home
  if (user && !location.hash) {
    return <Navigate to="/home" replace />;
  }

  return (
    <AnimatedPage>
      <Helmet htmlAttributes={{ lang: 'en' }}>
        <title>Chito - Simplify Your Chit Fund Management</title>
        <meta name="description" content="An intuitive platform designed specifically for chit fund managers to organize, track, and grow their funds with ease." />
        <meta name="keywords" content="chit fund, management, financial, tracking, payments, chit fund software, chit fund app" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://chito.in" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://chito.in" />
        <meta property="og:title" content="Chito - Simplify Your Chit Fund Management" />
        <meta property="og:description" content="An intuitive platform designed specifically for chit fund managers to organize, track, and grow their funds with ease." />
        <meta property="og:image" content="https://chito.in/og-image.jpg" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://chito.in" />
        <meta name="twitter:title" content="Chito - Simplify Your Chit Fund Management" />
        <meta name="twitter:description" content="An intuitive platform designed specifically for chit fund managers to organize, track, and grow their funds with ease." />
        <meta name="twitter:image" content="https://chito.in/twitter-image.jpg" />
        
        {/* Additional SEO tags */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Your Company Name" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        
        {/* JSON-LD structured data for better rich snippets */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "Chito",
            "description": "An intuitive platform designed specifically for chit fund managers to organize, track, and grow their funds with ease.",
            "applicationCategory": "FinanceApplication",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "INR"
            }
          })}
        </script>
      </Helmet>

      <div className="flex flex-col min-h-screen w-full overflow-hidden">
        <LandingHeader />
        <main className="flex-grow">
          <HeroSection />
          <FeaturesSection />
          <TestimonialsSection />
          <PricingSection />
        </main>
        <LandingFooter />
      </div>
    </AnimatedPage>
  );
};

export default Index;
